module.exports = __webpack_public_path__ + "img/QRCode.91c705ba.svg";